var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.actualCountryCode
    ? _c("span", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.right",
            value: _vm.actualCountryCode,
            expression: "actualCountryCode",
            modifiers: { right: true }
          }
        ],
        class: ["flag", _vm.actualCountryCode.toLowerCase()]
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }